const CURRENCY_FIELD_KEYWORDS = [
  "amount",
  "cost",
  "expense",
  "fee",
  "price",
  "revenue",
  "salary",
];

const NON_CURRENCY_FIELD_KEYWORDS = [
  "distance",
  "km",
  "kilometer",
  "kilometre",
];

export const getImportValueByDataIndex = (record: any, dataIndex: any) => {
  if (!record) return undefined;

  const direct = record?.[dataIndex as any];
  if (direct !== undefined) return direct;

  if (Array.isArray(dataIndex)) {
    return dataIndex.reduce(
      (acc, key) => (acc ? acc[key] : undefined),
      record,
    );
  }

  if (typeof dataIndex === "string" && dataIndex.includes(".")) {
    return dataIndex
      .split(".")
      .reduce((acc, key) => (acc ? acc[key] : undefined), record);
  }

  return undefined;
};

const getColumnSearchText = (column: any) => {
  const dataIndexText = Array.isArray(column?.dataIndex)
    ? column.dataIndex.join(".")
    : String(column?.dataIndex ?? "");
  const titleText =
    typeof column?.title === "string" ? column.title : String(column?.title ?? "");
  const importTitleText =
    typeof column?.importTitle === "string" ? column.importTitle : "";

  return `${dataIndexText} ${titleText} ${importTitleText}`.toLowerCase();
};

const hasCurrencyFormatter = (column: any) => {
  const formatterText = String(column?.editProps?.formatter ?? "");
  const colReturnText = String(column?.colReturn ?? "");

  return (
    formatterText.includes("đ") ||
    formatterText.includes("\\u0111") ||
    colReturnText.includes("đ") ||
    colReturnText.includes("\\u0111")
  );
};

export const isCurrencyImportColumn = (column: any) => {
  const searchText = getColumnSearchText(column);

  if (
    NON_CURRENCY_FIELD_KEYWORDS.some((keyword) => searchText.includes(keyword))
  ) {
    return false;
  }

  const isNumberInput =
    column?.editType === "InputNumber" || column?.displayType === "InputNumber";

  if (hasCurrencyFormatter(column)) return true;
  if (!isNumberInput) return false;

  return CURRENCY_FIELD_KEYWORDS.some((keyword) => searchText.includes(keyword));
};

const toDisplayNumber = (value: any) => {
  if (typeof value === "number") return value;

  const normalized = String(value ?? "").replace(/[^\d.-]/g, "");
  const numberValue = Number(normalized);

  return Number.isFinite(numberValue) ? numberValue : null;
};

export const formatImportPreviewValue = (value: any, column: any) => {
  if (value === null || value === undefined) return "";

  if (!isCurrencyImportColumn(column)) return String(value);

  const numberValue = toDisplayNumber(value);
  if (numberValue === null) return String(value);

  return `${numberValue.toLocaleString("vi-VN")} đ`;
};
